import EducationSlide01 from "../assets/images/education/educationSlide01.webp";
import EducationSlide02 from "../assets/images/education/educationSlide02.webp";
import EducationSlide03 from "../assets/images/education/educationSlide03.webp";
import EducationSlide04 from "../assets/images/education/educationSlide04.webp";
import EducationSlide05 from "../assets/images/education/educationSlide05.webp";
import EducationSlide06 from "../assets/images/education/educationSlide06.webp";
import EducationSlide07 from "../assets/images/education/educationSlide07.webp";
import EducationSlide08 from "../assets/images/education/educationSlide08.webp";
import EducationSlide09 from "../assets/images/education/educationSlide09.webp";
import EducationSlide10 from "../assets/images/education/educationSlide10.webp";
import EducationSlide11 from "../assets/images/education/educationSlide11.webp";
import EducationSlide12 from "../assets/images/education/educationSlide12.webp";
import EducationSlide13 from "../assets/images/education/educationSlide13.webp";
import EducationSlide14 from "../assets/images/education/educationSlide14.webp";

// S ::::: 교육 슬라이드 ::::: S
export const educationSlides = [
  // {
  //   img: EducationSlide01,
  // },
  // {
  //   img: EducationSlide02,
  // },
  // {
  //   img: EducationSlide03,
  // },
  // {
  //   img: EducationSlide04,
  // },
  {
    img: EducationSlide05,
  },
  // {
  //   img: EducationSlide06,
  // },
  {
    img: EducationSlide07,
  },
  {
    img: EducationSlide08,
  },
  {
    img: EducationSlide09,
  },
  // {
  //   img: EducationSlide10,
  // },
  {
    img: EducationSlide11,
  },
  {
    img: EducationSlide12,
  },
  {
    img: EducationSlide13,
  },
  {
    img: EducationSlide14,
  },
];
// E ::::: 교육 슬라이드 ::::: E
